module.exports = __webpack_public_path__ + "static/media/ic_compagons_checked.cab22b5d.svg";